import request from "@/utils/server.js";
// 产品模块
// 官网后台支付接口
export function getWxPay_NATIVEAPI(data) {
  return request({
    url: "/wx/pay/NATIVE",
    method: "post",
    data,
  });
}
